import BackIcon from "../../assets/logo/BackIcon";
import {PaymentMethod} from "../../services/exports/Constants";
import {PaymentOptionPropertiesInterface, ThemeInterface,} from "../../services/exports/Interfaces";
import CreditCardIcon from "../../assets/logo/CreditCardIcon";
import PayPalIcon from "../../assets/logo/PayPalIcon";
import KlarnaIcon from "../../assets/logo/KlarnaIcon";
import GiroPayIcon from "../../assets/logo/GiroPayIcon";
import IbanIcon from "../../assets/logo/IbanIcon";
import useTheme from "../../hooks/useTheme";
import ApplePayIcon from "../../assets/logo/ApplePayIcon";
import GooglePayIcon from "../../assets/logo/GooglePayIcon";
import CashIcon from "../../assets/logo/payments/CashIcon";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {StoreInterface} from "../../store/types";

interface Props {
  item?: PaymentOptionPropertiesInterface;
  testId?: string;
  onClick: (item?: PaymentOptionPropertiesInterface) => void;
}

export default function PaymentMethodItem(props: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Payment:PaymentMethodItem' });

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { item, testId, onClick } = props;
  const theme: ThemeInterface = useTheme();

  const description = ({
    [PaymentMethod.Cash]: t(`descriptions.${PaymentMethod.Cash}`, { defaultValue: null }),
    [PaymentMethod.Paypal]: company?.has_paypal_upcharge
      ? t(`descriptions.${PaymentMethod.Paypal}`, { defaultValue: null })
      : null,
  })[item.payment_method_id] ?? null;

  function getPaymentIcon() {
    switch (item?.payment_method_id) {
      case PaymentMethod.Card:
        return (
          <CreditCardIcon
            className={creditCardIcon}
            color={theme.color.text.default}
          />
        );
      case PaymentMethod.Paypal:
        return <PayPalIcon className={payPalIcon} />;
      case PaymentMethod.Sofort:
        return <KlarnaIcon className={klarnaIcon} />;
      case PaymentMethod.Giropay:
        return <GiroPayIcon className={giroPayIcon} />;
      case PaymentMethod.SepaDebit:
        return <IbanIcon className={ibanIcon} />;
      case PaymentMethod.ApplePay:
        return <ApplePayIcon className={appleIcon} />;
      case PaymentMethod.GooglePay:
        return <GooglePayIcon className={googleIcon} />;
      case PaymentMethod.Cash:
        return <CashIcon className="h-4 w-5" />;
    }
  }

  function getTitle() {
    switch (item?.payment_method_id) {
      case PaymentMethod.Card:
      case PaymentMethod.SepaDebit:
        return `${item?.display_name} ***${item?.details}`;
      case PaymentMethod.Cash:
        return company?.has_in_store_card_payments ? t('payment_methods.cash_or_card_in_store') : t('payment_methods.cash')
      default:
        return item?.display_name;
    }
  }

  return (
    <button
      className={container}
      onClick={() => onClick(item)}
      data-test={testId}
    >
      <div className={wrapper}>
        <div className={iconContainer}>{getPaymentIcon()}</div>
        <div>
          <p className="text-left">{getTitle()}</p>
          {description && (
            <p className="text-tiny text-left">{description}</p>
          )}
        </div>
      </div>
      <div>
        <BackIcon color={theme.color.text.grey} className={backIcon} />
      </div>
    </button>
  );
}

const container =
  "flex flex-row w-full px-small py-xsmall border rounded border-brand-inkGrey-grey_2 items-center justify-between";

const wrapper = "w-full flex flex-row items-center";

const backIcon = "h-4 w-4 rotate-180";

const iconContainer =
  "rounded border border-brand-inkGrey-grey_2 w-9 h-8 flex justify-center items-center mr-mini";

const creditCardIcon = "h-6 w-6";

const payPalIcon = "h-7 w-7";

const klarnaIcon = "h-6 w-6";

const giroPayIcon = "h-6 w-6";

const ibanIcon = "h-6 w-6";

const appleIcon = "h-6 w-6";

const googleIcon = "h-10 w-10";
